module.exports = __webpack_public_path__ + "fonts/NanumSquareOTFB.5ee5e01f.ttf";